import { apiClient } from '../../gateways/api'
import type { GeblokkeerdeWeek } from '../types/GeblokkeerdeWeek'

export { patchGeblokkeerdeWeek }

const patchGeblokkeerdeWeek = async ({
  geblokkeerdeWeek,
}: {
  geblokkeerdeWeek: Partial<GeblokkeerdeWeek>
}): Promise<GeblokkeerdeWeek> => {
  const { data } = await apiClient({
    url: `/rest/planning/geblokkeerdeweken`,
    method: 'PUT',
    data: geblokkeerdeWeek,
  })
  return data
}
